import React from 'react';
import Axios from 'axios';
import {Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardHeader, CardBody} from 'reactstrap';


class QVNEAPaymentPopupModal extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			btnchecked: false
		};
		this.clickCheckbox = this.clickCheckbox.bind(this);
	}

	render() {
		// console.log('QVNEAPaymentPopupModal: render');
		return (
    	<Modal 
  			isOpen={this.props.showModal} 
				size="lg"
    		//toggle={this.props.handleModalCancel}		// when clicking outside the modal
    		className={this.props.className} >

    		<ModalHeader>
    			{/* toggle={this.props.handleModalCancel}> displays a small X in header */}
    			PAIEMENT DE VOTRE LIGUE
    		</ModalHeader>

    		<ModalBody>
					{this.dispModalBody2023()}
    		</ModalBody>

    		<ModalFooter>
        	<div className="row row-margin-bottom-10">
        	<div className="col-12 text-left chkboxtext">
						<input type="checkbox" onChange={this.clickCheckbox} checked={this.state.btnchecked} />
						&nbsp;&nbsp;J'ai lu et compris mon engagement
					</div>
					</div>

        	<div className="row">
        	<div className="col-12 text-center">
	      		<button className="btn btn-qpumod" 
	      			disabled={!this.state.btnchecked} onClick={this.props.handleModalCancel}> <strong>J'ACCEPTE</strong>
	      		</button>
					</div>
					</div>

    		</ModalFooter>
    	</Modal>
    )
	}


	dispModalBody2023() {
		return (
			<div>
        <div className="row">
        <div className="text-center">
					<img className="img-fluid" src="/img/qvnea-comment-payer.jpg" alt="qvnea" />					
				</div>
				</div>
			</div>
		)
	}

	dispModalBody2022() {
		return (
			<div>
        <div className="row row-margin-bottom-10">
        <div className="col-12 text-center">
					<img className="img-fluid" src="/img/qvnea_logo_02.jpg" alt="qvnea" width="150"/>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12 text-center">
					<h5> IMPORTANT – BIEN LIRE </h5>
				</div>
				</div>

        <div className="row">
        <div className="col-12">
					<p>
						Dans le but de maintenir les frais au plus bas, soit 25$ par saison pour le secrétariat (stats, comptabilité, papeterie), il est 
						important de faciliter les opérations. Nous passons beaucoup de temps à collecter les frais d’inscriptions des joueurs. 
					</p>
					<p>
						Dans toutes les activités de ligue que nous connaissons (quilles, softball, hockey etc), les participants doivent payer la ligue 
						avant de la commencer. Nous n’en sommes pas rendus à cette obligation. Toutefois, dans un monde idéal où toutes les inscriptions étaient payées avant la 
						fin de la saison, Cynthia pourrait préparer à l’avance l’ensemble des bourses. Nous pourrions ainsi les distribuer durant les 
						finales de fin de saison, un moment où l’on vous croise tous ou à peu près, mais on est loin du compte.
					</p>
					<p>
						Plusieurs nous payent à la dernière minute, ce qui implique que nous ne pouvons pas préparer les bourses à l’avance. 
						Nous devons faire des virements. Mais les virements, c’est maximum 3000$/jour et 20 000$/mois. C’est très compliqué et très 
						long comme processus. Il y en a d’autres qui nous soustrait de leur inscription leurs bourses gagnées à la mi-saison. Cela nous 
						oblige donc à faire la recherche dans toutes les équipes et calculer pour chacun s'ils ont droit à une bourse ou s’il reste un 
						montant à payer. C’est interminable!
					</p>
					<p>
						Cette année, nous demandons à tous les joueurs de payer avant le 31 décembre 2022. Nous pourrons préparer les bourses en un temps 
						minimum, les distribuer en quelques heures et ainsi pouvoir satisfaire les joueurs plus rapidement.
						Pour que ce projet marche, des joueurs nous ont proposé de mettre une surcharge pour les retardataires. Ceux qui paieront après le 
						1er janvier devront donc payer 50$ de plus. Si vous avez besoin d’une extension pour payer, vous devrez prendre contact avec Cynthia 
						pour lui donner un échéancier pour le paiement. Si vous ne respectez pas cet échéancier, la surcharge de 50$ va s’appliquer. 
						Le but n’est pas de collecter des 50$ mais plutôt de diminuer les efforts inutiles pour la gestion de vos inscriptions et de vos bourses.
						Au début décembre, nous rendrons public le solde de chacun des joueurs dans les différentes divisions pour que vous sachiez s’il 
						vous reste un montant à donner. Un rappel de paiement sera également effectué en novembre.
					</p>
					<p>
						Veuillez svp passer le message à vos coéquipiers pour s’assurer que tous les joueurs soient au courant de cette nouvelle mesure.  
						Ce message sera présent sur les sites de QVNEA et Statelo jusqu’au mois d’octobre.
					</p>
				</div>
				</div>
			</div>
		)
	}

	clickCheckbox() {
		this.setState({
			btnchecked: !this.state.btnchecked
		});
	}

}

export default QVNEAPaymentPopupModal;